<template>
  <div class="worldmap-page">
    <div class="content-scroll">
      <div class="content-card">
        <div class="section">
          <h3>总图</h3>
          <div class="map-wrap">
            <img :src="ossPath + 'help/map1.gif'" alt="世界总图">
          </div>
        </div>

        <div class="section">
          <h3>王都维达尔加</h3>
          <div class="map-wrap">
            <img class="map-open-img" :src="ossPath + 'help/map2.gif'" alt="王都维达尔加" @click="openMap" title="点击查看动态地图">
          </div>
        </div>

        <div class="section">
          <h3>幻之都六芒星（在建）</h3>
          <div class="map-wrap">
            <img :src="ossPath + 'help/map3.gif'" alt="幻之都六芒星">
          </div>
        </div>

        <div class="section">
          <h3>音乐城市月光岛（在建）</h3>
          <div class="map-wrap">
            <img :src="ossPath + 'help/map4.gif'" alt="音乐城市月光岛">
          </div>
        </div>
      </div>
    </div>

    <div class="bottom-fixed">
      <div class="back-link">
        <router-link :to="{name:'guideIndex'}">← 返回旅游指南</router-link>
      </div>
      <div class="page-footer">
        <div class="copyright">
          ©Copyright 2019 <a href="http://www.huanzhidadi.com" target="_blank">幻之大地</a> ALL RIGHTS RESERVED. <a href="https://beian.miit.gov.cn" target="_blank" title="豫ICP备17045248号-3">豫ICP备17045248号-3</a>
        </div>
        <div class="advice">
          抵制不良游戏，拒绝盗版游戏。注意自我保护，谨防受骗上当。<br/>适度游戏益脑，沉迷游戏伤身。合理安排时间，享受健康生活。
        </div>
      </div>
      </div>

      <!-- 王都动态地图弹窗（不开新页） -->
      <wangdu-dialog ref="wangduDialog"></wangdu-dialog>
    </div>
</template>
<script>
  import wangduDialog from '../maps/wangduDialog.vue';
  export default{
    components: { wangduDialog },
    methods: {
      openMap() {
        this.$refs.wangduDialog.open();
      }
    },
    mounted: function () {
      var _this = this;
    },
    data(){
      return {
      }
    }
  }

</script>
<style scoped>
.worldmap-page {
  flex: 1;
  min-height: 0;
  max-width: 720px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  padding: 0;
}

/* ========== 正文滚动区 ========== */
.content-scroll {
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 12px 12px 0;
}

.content-card {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  padding: 28px 30px;
  box-sizing: border-box;
}

.section {
  margin-bottom: 24px;
}

.section:last-child {
  margin-bottom: 0;
}

.section h3 {
  margin: 0 0 12px;
  font-size: 16px;
  color: #303133;
  padding-left: 8px;
  border-left: 3px solid #409eff;
}

.map-wrap {
  text-align: center;
}

.map-wrap img {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  border: 1px solid #ebeef5;
}

/* ========== 底部固定区 ========== */
.bottom-fixed {
  flex-shrink: 0;
  padding: 0 16px;
}

.back-link {
  text-align: center;
  padding: 10px 0;
}

.back-link a {
  font-size: 14px;
  color: #909399;
  text-decoration: none;
  transition: color 0.2s;
}

.back-link a:hover {
  color: #409eff;
}

.page-footer {
  text-align: center;
  padding-bottom: 16px;
}

.page-footer .copyright {
  font-size: 12px;
  color: #999;
  line-height: 1.6;
}

.page-footer .copyright a {
  color: #909399;
  text-decoration: none;
}

.page-footer .copyright a:hover {
  color: #409eff;
}

.page-footer .advice {
  font-size: 11px;
  color: #aaa;
  line-height: 1.7;
  margin-top: 4px;
}

/* ========== 移动端适配 ========== */
@media (max-width: 768px) {
  .content-scroll {
    padding: 8px 8px 0;
  }

  .content-card {
    padding: 20px 16px;
    border-radius: 10px;
  }

  .section {
    margin-bottom: 18px;
  }

  .section h3 {
    font-size: 15px;
    margin-bottom: 10px;
  }

  .back-link a {
    font-size: 13px;
  }

  .bottom-fixed {
    padding: 0 10px;
  }

  .page-footer .copyright {
    font-size: 10px;
  }

  .page-footer .advice {
    font-size: 10px;
  }
}
</style>
